function getAPIKey() {
    const key = 'ceb1c090a42dc8194474d78e3e1db6a7';
    return key.split('').reverse().join('');
}

export default getAPIKey